import { defineMessages } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { type ProfileProps } from '@atlaskit/atlassian-navigation';
import { type TriggerProps } from '@atlaskit/popup';

export type AccountMenuTriggerProps = Pick<ProfileProps, 'onClick' | 'testId'> &
	TriggerProps & {
		email: string | undefined;
		picture: string | undefined;
		trustPicture?: boolean;
	};

export const messages: {
	triggerTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	triggerTooltip: {
		id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
		defaultMessage: 'Account',
		description: 'Tooltip and alt-text for the account menu item',
	},
});
